<!-- Card utilisée pour la section Why Us -->

<template>
  <v-col cols="12" sm="6" md="4">
    <v-card flat class="fill-height">
      <v-img :src="image" height="250" class="rounded-lg mb-4"></v-img>
      <v-card-text>
        <ul class="text-h6 font-weight-light">
          <li v-for="(point, j) in points" :key="j" class="mb-2">
            {{ point }}
          </li>
        </ul>
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  name: "whyUsCard",
  props: {
    image: {
      type: String,
      required: true,
    },
    points: {
      type: Array,
      required: true,
    },
  },
});
</script>
